var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64287 10.4284C11.8126 10.4284 13.5714 8.66955 13.5714 6.49986C13.5714 4.33017 11.8126 2.57129 9.64287 2.57129C7.47318 2.57129 5.71429 4.33017 5.71429 6.49986C5.71429 8.66955 7.47318 10.4284 9.64287 10.4284Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.4285C4.69286 10.4285 1 14.1213 1 18.6785C1 20.2028 2.22571 21.4285 3.75 21.4285H14.75C16.2743 21.4285 17.5 20.2028 17.5 18.6785C17.5 14.1213 13.8071 10.4285 9.25 10.4285Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1957 10.6956C15.4414 10.6956 14.7186 10.8527 14.0271 11.0727C16.9971 12.3298 19.0714 15.2527 19.0714 18.6784C19.0714 19.1027 18.9614 19.4956 18.8043 19.857H20.7371C21.9943 19.857 23 18.8356 23 17.5941V17.4998C23 13.7441 19.9514 10.6956 16.1957 10.6956Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 10.6957C18.3014 10.6957 19.7471 9.23425 19.7471 7.42711C19.7471 5.61997 18.3014 4.14282 16.51 4.14282C15.8343 4.14282 15.2057 4.34711 14.6871 4.70854C14.97 5.24282 15.1429 5.85568 15.1429 6.49997C15.1429 7.63139 14.6714 8.63711 13.9014 9.34425C14.4986 10.1614 15.4414 10.6957 16.51 10.6957Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18.8571,
    transform: "translate(1 2.57129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserList);
export default __webpack_public_path__ + "static/media/UserList.e10e2ea19e24420fa0746008598e9cf6.svg";
export { ForwardRef as ReactComponent };